import React from 'react';
import styled from 'styled-components';

import Txt from '../atoms/Txt';
import Row from '../atoms/FlexRow';
import Col from '../atoms/FlexColumn';
import HorSpacer from '../atoms/HorSpacer';

import theme from '../../constants/AppTheme';

const IconWrapper = styled.div`
  i {
    font-size: 45px;
    border-radius: 50%;
    border: solid 2px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 80px;
    height: 80px;
  }
`;

export const CreditCard = ({
  lastDigits,
  expirationMonth,
  expirationYear,
  onDelete = null,
  onSelect = null
}) => (
  <Row>
    <IconWrapper>
      <i className="far fa-credit-card" />
    </IconWrapper>
    <HorSpacer size={30} />
    <Col align="flex-start" style={{ flex: 1 }}>
      <Txt color={theme.black} size="18px">
        Terminado em {lastDigits}
      </Txt>
      <Txt color={theme.black} size="18px">
        Vencimento: {expirationMonth}/{expirationYear}
      </Txt>
    </Col>
    <HorSpacer size={30} />
    {onDelete && (
      <button onClick={onDelete}>
        <Txt color={theme.blue} size="18px">
          Excluir
        </Txt>
      </button>
    )}
    {onSelect && (
      <button onClick={onSelect}>
        <Txt color={theme.blue} size="18px">
          Selecionar
        </Txt>
      </button>
    )}
  </Row>
);
